import React from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
const About = () => {
  const { ref: imageRef, inView: imageInView } = useInView({
      triggerOnce: true,
      threshold: 0.3, // Trigger when 30% of the element is visible
    });
  
    const { ref: textRef, inView: textInView } = useInView({
      triggerOnce: true,
      threshold: 0.3, // Trigger when 30% of the element is visible
    });
  
    // Define animation variants for framer-motion
    const imageVariants = {
      hidden: { opacity: 0, x: -100 },
      visible: { opacity: 1, x: 0, transition: { duration: 1, delay:0.8 } },
    };
  
    const textVariants = {
      hidden: { opacity: 0, y: 50 },
      visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.8 } },
    };
    return (
      <section className=" bg-gray-100">
      <div className="about-section py-24 bg-gradient-to-r from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-12 md:space-y-0 gap-16">
          {/* Left Division: Image */}
          <motion.div
            ref={imageRef}
            variants={imageVariants}
            initial="hidden"
            animate={imageInView ? "visible" : "hidden"}
            className="w-full md:w-1/2"
          >
            <img
              src="../landing.jpg" // Replace with your image path
              alt="Consultancy"
              className="w-full h-auto object-cover rounded-lg shadow-xl transform hover:scale-110 transition-transform duration-300"
            />
          </motion.div>

          {/* Right Division: Consultancy Details */}
          <motion.div
            ref={textRef}
            variants={textVariants}
            initial="hidden"
            animate={textInView ? "visible" : "hidden"}
            className="w-full md:w-1/2 text-center md:text-left space-y-6"
          >
            <h2 className="text-4xl font-semibold text-white leading-tight">
              About Us
            </h2>
            <p className="text-xl text-justify text-gray-200">
              At Zenetix, we specialize in providing top-notch IT consultancy services
              that help businesses innovate, grow, and streamline their operations. We focus on
              empowering our clients with the tools and insights they need to succeed in the digital age.
            </p>
            <p className="text-xl text-justify text-gray-200">
              Our team of experts offers customized solutions in cloud computing, software development,
              business intelligence, and more. We ensure that your business stays ahead of the competition.
            </p>
            <p className="text-xl text-justify text-gray-200">
              With a focus on quality, innovation, and customer satisfaction, Zenetix is your trusted partner
              for navigating the ever-evolving tech landscape.
            </p>
            <Link
              to="/contact"
              className="inline-block no-underline mt-6 text-white bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
            >
              Get In Touch
            </Link>
          </motion.div>
        </div>

        {/* Section Divider */}
        <div className="w-full mt-16 h-1 bg-gradient-to-r from-teal-400 to-blue-600 rounded-full mx-auto" />
      </div>
    </div>
      </section>
    );
  };
  
  export default About;